import React, { useState, useEffect, useRef } from "react";
import { FaCheckCircle, FaTrash, FaToggleOn, FaToggleOff } from "react-icons/fa";
import "../assets/css/autotrade.css";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import Loader from "../components/Loader";
import ConfirmBuyModal from "../components/ConfirmBuyModal";
import axios from "axios";

import { ITreasureContract, USDTContarct } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import USDTABI from "../abis/USDTABI.json";

const AutoTrading = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [USDTBalance, setUSDTBalance] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const [botAmount, setBotAmount] = useState(0);
  const [usedAmountState, setUsedAmount] = useState(0);
  const [availableAmount, setAvailableAmount] = useState(0);

  const [autoFlag, setAutoFlag] = useState(false);
  const [enableTimestampState, setEnableTimestampState] = useState(0);
  const [unlockTimeState, setUnlockTimeState] = useState(0);
  const [gasFee, setGasFee] = useState(0);
  const [tradeAmount, setTradeAmount] = useState(0);
  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [amount, setAmount] = useState("");
  const [isLoading, setIsLoading] = useState(true);


  const [modalStatus, setModalStatus] = useState({
    visible: false,
    type: "",
    title: "",
    message: "",
    persist: false,
  });

  const timerRef = useRef(null);

  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(2) : "0.00";

  
  // INIT WEB3
  useEffect(() => {
    if (!client) return;
    try {
      const provider = client?.transport || window.ethereum;
      if (provider) setWeb3(new Web3(provider));
    } catch (err) {
      console.log("Web3 Init Error:", err);
    }
  }, [client]);

  useEffect(() => {
    if (!amount || !selectedPlan) {
      setGasFee(0);
      setTradeAmount(0);
      setTermsAccepted(false);
      return;
    }

    const amt = Number(amount);
    let percent = 0;

    if (selectedPlan === 1) percent = 0.2;
    if (selectedPlan === 7) percent = 0.2;
    if (selectedPlan === 30) percent = 1;

    const fee = (amt * percent) / 100;
    const net = amt - fee;

    setGasFee(fee);
    setTradeAmount(net);
  }, [amount, selectedPlan]);

  // TIMER FUNCTION
  const startTimer = (unlockTime) => {
    if (timerRef.current) return;

    timerRef.current = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      let remaining = unlockTime - now;

      if (remaining <= 0) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }

      const days = Math.floor(remaining / 86400);
      remaining %= 86400;
      const hours = Math.floor(remaining / 3600);
      remaining %= 3600;
      const minutes = Math.floor(remaining / 60);
      const seconds = remaining % 60;

      setTime({ days, hours, minutes, seconds });
    }, 1000);
  };

  // CLEANUP TIMER
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  // 🔥 BUY NFT ON CARD CLICK
const handleBuyNFT = async () => {
  if (!web3 || !address) {
    setModalStatus({
      visible: true,
      type: "error",
      title: "Wallet Error",
      message: "Wallet not connected",
    });
    return;
  }

  try {
    setModalStatus({
      visible: true,
      type: "loading",
      title: "Processing",
      message: "Buying NFT...",
    });

    const Contract = new web3.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    await Contract.methods
      .buyNFT(address)          // 👈 trader = connected wallet
      .send({ from: address });

    setModalStatus({
      visible: true,
      type: "success",
      title: "Success",
      message: "NFT BOT bought successfully!",
    });

    fetchData(); // refresh balances
  } catch (err) {
    console.error("Buy NFT Error:", err);
    setModalStatus({
      visible: true,
      type: "error",
      title: "Transaction Failed",
      message: err?.message || "Something went wrong",
    });
  }
};


  // FETCH DATA
  const fetchData = async () => {
    if (!web3 || !address) return;

    try {
      setIsLoading(true);

      const USDTInstance = new web3.eth.Contract(USDTABI, USDTContarct);
      const rawUSDT = await USDTInstance.methods.balanceOf(address).call();
      setUSDTBalance(web3.utils.fromWei(rawUSDT.toString(), "ether"));

      const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
      const poolData = await Contract.methods.objPool(address).call();

      const userTradingBalance = Number(web3.utils.fromWei(poolData[0], "ether"));
      const userDailyLimit = Number(web3.utils.fromWei(poolData[1], "ether"));
      const usedToday = Number(web3.utils.fromWei(poolData[2], "ether"));
      const enableTimestamp = Number(poolData.enableTimestamp);
      const unlockTimestamp = Number(poolData.unlockTimestamp);

      setBotAmount(userTradingBalance);
      setUsedAmount(usedToday);
      setAvailableAmount(userDailyLimit);
      setEnableTimestampState(enableTimestamp);
      setUnlockTimeState(unlockTimestamp);
      setAutoFlag(poolData.autoFlag);

      const now = Math.floor(Date.now() / 1000);
      if (enableTimestamp > 0 && unlockTimestamp > now) {
        startTimer(unlockTimestamp);
      } else {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
        setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      setModalStatus({ visible: true, type: "error", title: "Fetch Error", message: err.message });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (isConnected && web3 && address) fetchData();
  }, [isConnected, web3, address]);

  // BOT CONDITIONS
  const now = Math.floor(Date.now() / 1000);
  const isTimerRunning = enableTimestampState > 0 && unlockTimeState > now;
  const hideAllButtons = !isTimerRunning && !autoFlag;

  // HANDLE SETUP
  const handleSetup = async () => {
    if (!selectedPlan || !amount) {
      setModalStatus({ visible: true, type: "error", title: "Invalid Input", message: "Select plan and amount.", persist: true });
      return;
    }

    if (Number(amount) < 15) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Minimum Amount Required",
        message: "Minimum 15 USDT required to activate trading bot.",
        persist: true,
      });
      return;
    }

    if (Number(amount) > 400) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Limit Exceeded",
        message: "Maximum 300 USDT allowed per trading bot.",
        persist: true,
      });
      return; // ❌ STOP – MetaMask will NOT open
    }


    if (!termsAccepted) {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Terms Required",
        message: "Please accept Terms & Conditions",
        persist: true,
      });
      return;
    }

    if (!web3 || !address) {
      setModalStatus({ visible: true, type: "error", title: "Wallet Error", message: "Wallet not connected!", persist: true });
      return;
    }

    try {
     // ⭐ STEP 1: USER REGISTERED CHECK
    const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);
    const user = await Contract.methods.objUser(address).call();

    if (!user?.userId || user.userId === "0") {
      setModalStatus({
        visible: true,
        type: "error",
        title: "Not Registered",
        message: "Please register first before enabling trading bot.",
        persist: true,
        setModalStatus,
      });
      return; // ❌ STOP HERE (MetaMask will NOT open)
    }

      const tradeType =
        selectedPlan === 1 ? 1 :
        selectedPlan === 7 ? 2 :
        selectedPlan === 30 ? 3 : 0;

      const USDT = new web3.eth.Contract(USDTABI, USDTContarct);

      const amountWei = web3.utils.toWei(amount, "ether");

      setModalStatus({ visible: true, type: "loading", title: "Processing", message: "Approving & enabling bot..." });

      await USDT.methods.approve(ITreasureContract, amountWei).send({ from: address });
      await Contract.methods.enableTradingBot(amountWei, tradeType).send({ from: address });
       //  Small wait (avoid race condition)
      await new Promise((resolve) => setTimeout(resolve, 3000));

      // ================= BACKEND API CALL =================
      // 4. Step 3: Backend Sync
        setModalStatus({ visible: true, type: "loading", title: "Finalizing", message: "Syncing with server..." });

       
        const response = await axios.post(
            "https://daemon.takshitsolutions.com/api/app/v1/enable-bot",
            {
              wallet: address.toLowerCase(),
              usdtLimits: amountWei.toString(),
              botType: Number(tradeType),
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
        );

        console.log("Success:", response.data);

        setModalStatus({ 
            visible: true, 
            type: "success", 
            title: "Success", 
            message: "Trading bot enabled and synced successfully!" 
        });
        
        if(typeof fetchData === "function") fetchData();

    } catch (err) {
        console.error("Detailed Setup Error:", err);
        
        let friendlyMessage = err.message;
        if (err.message.includes("Failed to fetch")) {
            friendlyMessage = "Server Connection Failed. Please check your internet or contact support (CORS issue).";
        }

        setModalStatus({
            visible: true,
            type: "error",
            title: "Setup Failed",
            message: friendlyMessage,
            persist: true,
        });
    }
};

  const handleBotAction = async (action) => {
  try {
    const Contract = new web3.eth.Contract(ITreasureContractABI, ITreasureContract);

    // SPECIAL CHECK FOR REMOVE
   if (action === "remove") {
  const now = Math.floor(Date.now() / 1000);
  if (unlockTimeState > now) {
    setModalStatus({
      visible: true,
      type: "confirm",
      title: "Time Not Completed",
      message: "Your bot's scheduled time is not finished yet. If you remove it now, 5% of your amount will be deducted. Do you want to proceed?",
      persist: true,
      onConfirm: async () => {
        try {
          await Contract.methods.removeTradingBot().send({ from: address });

            // 🔹 2. BACKEND API CALL (DISABLE BOT)
              await axios.post(
                "https://daemon.takshitsolutions.com/api/app/v1/disable-bot",
                {
                  wallet: address.toLowerCase(),
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );

          setModalStatus({
            visible: true,
            type: "success",
            title: "Success",
            message: "Bot removed successfully!"
          });
          setSelectedPlan(null);
          setAmount("");
          fetchData();
        } catch (err) {
          setModalStatus({
            visible: true,
            type: "error",
            title: "Remove Failed",
            message: err.message
          });
        }
      },
    });
    return; // Wait for user to confirm
  }
}


    // OTHER ACTIONS OR REMOVE IF TIME IS ZERO
    let msg = "";
    setModalStatus({ visible: true, type: "loading", title: "Processing", message: "Please wait..." });

    if (action === "enable") {
      await Contract.methods.enableBot().send({ from: address });
      msg = "Bot enabled!";
    } else if (action === "disable") {
      await Contract.methods.disableBot().send({ from: address });
      msg = "Bot disabled!";
    } else if (action === "remove") {
      await Contract.methods.removeTradingBot().send({ from: address });
      msg = "Bot removed!";
      setSelectedPlan(null);
      setAmount("");
    }

    setModalStatus({ visible: true, type: "success", title: "Success", message: msg });
    fetchData();

  } catch (err) {
    console.error("Bot Action Error:", err);
    setModalStatus({ visible: true, type: "error", title: "Action Failed", message: err.message });
  }
};


  if (isLoading) return <Loader />;

  return (
    <>
      <h4 className="auto-title">
        <span className="yellow">Auto</span> <span className="light">Trade</span>
      </h4>

      <div className="card">
        <div className="card-body">
          <div className="auto-body">

            {isTimerRunning && (
              <div className="auto-timer-box">
                <div className="auto-timer-item">
                  <div className="auto-timer-number">{String(time.days).padStart(2, "0")}</div>
                  <div className="auto-label">DAY</div>
                </div>
                <div className="auto-sep">:</div>
                <div className="auto-timer-item">
                  <div className="auto-timer-number">{String(time.hours).padStart(2, "0")}</div>
                  <div className="auto-label">HRS</div>
                </div>
                <div className="auto-sep">:</div>
                <div className="auto-timer-item">
                  <div className="auto-timer-number">{String(time.minutes).padStart(2, "0")}</div>
                  <div className="auto-label">MIN</div>
                </div>
                <div className="auto-sep">:</div>
                <div className="auto-timer-item">
                  <div className="auto-timer-number">{String(time.seconds).padStart(2, "0")}</div>
                  <div className="auto-label">SEC</div>
                </div>
              </div>
            )}

            <div className="auto-wallet-card">
              <div className="auto-wallet-label">Wallet Balance</div>
              <div className="auto-wallet-amount">{formatBalance(USDTBalance)} USDT</div>
            </div>


            {!isTimerRunning && (
              <>
                <div className="auto-plan-btn-box">
                  <button className={`auto-btn btnauto-1 ${selectedPlan === 1 ? "auto-active-btn" : ""}`} onClick={() => setSelectedPlan(1)}>1 DAY</button>
                  <button className={`auto-btn btnauto-2 ${selectedPlan === 7 ? "auto-active-btn" : ""}`} onClick={() => setSelectedPlan(7)}>7 DAYS</button>
                  <button className={`auto-btn btnauto-3 ${selectedPlan === 30 ? "auto-active-btn" : ""}`} onClick={() => setSelectedPlan(30)}>30 DAYS</button>
                </div>

                {selectedPlan && (
                  <div className="auto-input-box">
                    <label>Enter Amount USDT</label>
                    <div className="inpit-doller">
                      <input
                        type="number"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        placeholder="Enter USDT amount"
                        className="auto-input"
                      />
                      <span className="iput-icon">   <i className="fa-solid fa-dollar-sign"></i></span>
                    </div>
                  </div>
                )}

                {/* 🔥 SUMMARY BOX */}
                {/* {amount && selectedPlan && (
            <div className="auto-card-wrap">
              <div className="auto-amount-card"><b>{Number(amount).toFixed(2)} <small>USDT</small> </b> <small className="sm-text">Total Amount</small>  </div>
              <div className="auto-amount-card"><b>{gasFee.toFixed(2)} <small>USDT</small> </b> <small className="sm-text">Gas Fee</small> </div>
              <div className="auto-amount-card"> <b>{tradeAmount.toFixed(2)} <small>USDT</small></b> <small className="sm-text">Trading Amount</small>  </div>
            </div>
          )} */}

                {amount && selectedPlan && (
                  <>
                    <div className="auto-card-wrap">
                      <div className="auto-amount-card">{amount} USDT<br /><small>Total</small></div>
                      <div className="auto-amount-card">{gasFee.toFixed(2)} USDT<br /><small>Gas</small></div>
                      <div className="auto-amount-card">{tradeAmount.toFixed(2)} USDT<br /><small>Trade</small></div>
                    </div>

                    {/* ===== TERMS (SHOW AFTER AMOUNT) ===== */}
                    <div className="form-check mt-3 terms-row">
                      <input
                        className="form-check-input terms-checkbox"
                        type="checkbox"
                        id="termsCheck"
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                      />
                      <label className="form-check-label terms-label" htmlFor="termsCheck">
                        I agree to the{" "}
                        <span
                          className="terms-link"
                          onClick={() => setShowTermsModal(true)}
                        >
                          Terms & Conditions
                        </span>
                      </label>
                    </div>

                  </>
                )}



                <button className="btn btn-success handleSetupbtn" onClick={handleSetup}>
                  Setup
                </button>


              </>
            )}


            {!hideAllButtons && (
              <div className="auto-ctrl-row">
                {/* {!autoFlag && (
                  <button className="enable-slide-btn combtn enabled" onClick={()=>handleBotAction("enable")}>
                    <FaToggleOn /> <span className="ms-2">Enable</span>
                  </button>
                )}
                {autoFlag && (
                  <button className="enable-slide-btn combtn disabled" onClick={()=>handleBotAction("disable")}>
                    <FaToggleOff /> <span className="ms-2">Disable</span>
                  </button>
                )} */}
                <button className="btn btn-danger combtn" onClick={() => handleBotAction("remove")}>
                  <FaTrash className="me-2" /> Remove
                </button>
              </div>
            )}

            {isTimerRunning && (
              <div className="auto-card-wrap">
                <div className="auto-amount-card">{formatBalance(botAmount)} USDT<div className="auto-amount-title-tiny">Total Trading Amount</div></div>
                <div className="auto-amount-card">{formatBalance(usedAmountState)} USDT<div className="auto-amount-title-tiny">Used Daily Amount</div></div>
                <div className="auto-amount-card">{formatBalance(availableAmount)} USDT<div className="auto-amount-title-tiny">Daily Limit</div></div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div class="auto-body">

        <div
  className="auto-wallet-card"
  style={{ cursor: "pointer" }}
  onClick={handleBuyNFT}
>
  <div className="auto-wallet-label">
    Bot BUY
  </div>
  <div className="auto-wallet-amount">
    Bot BUY
  </div>
</div>

      </div>

       {/* ===== TERMS MODAL (SAME PAGE) ===== */}
     {showTermsModal && (
  <div className="terms-modal-overlay">
    <div className="terms-modal-box">
      <h5 className="terms-title">Terms & Conditions</h5>

      <div className="terms-content">
        <ol>
          <li>Trading involves market risk.</li>
          <li>Profits are not guaranteed.</li>
          <li>Losses may occur due to volatility.</li>
          <li>Bot performance depends on market conditions.</li>
          <li>User manages funds at own risk.</li>
          <li>No financial advice is provided.</li>
          <li>Smart contract execution is irreversible.</li>
          <li>Gas fees are non-refundable.</li>
          <li>Bot duration is fixed once activated.</li>
          <li>By proceeding, you accept all risks.</li>
        </ol>
      </div>

      <div className="terms-footer">
        <button
          className="btn btn-secondary"
          onClick={() => setShowTermsModal(false)}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}


      {/* STATUS MODAL */}
      <ConfirmBuyModal
        open={modalStatus.visible}
        status={{ ...modalStatus, setStatusText: setModalStatus }}
        onClose={() => setModalStatus({ ...modalStatus, visible: false })}
      />
    </>
  );
};

export default AutoTrading;